/**
 * Pool Point Calculation Page
 *
 * Displays file reports filtered by "Key Entitlement" category.
 * This page is a specialized view of the ReportsPage component
 * pre-filtered for pool point calculation documents.
 */

import { ReportsPage } from './ReportsPage';

export const PoolPointCalculationPage = () => {
  return <ReportsPage category="Key Entitlement" title="Pool Point Calculation" />;
};
